import React from 'react'

// material ui
import FormLabel from '@mui/material/FormLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

// components
import FormControlWithErrorHelper from 'components/shared/FormControlWithErrorHelper'

const FormSelectWithValidation = props => {
  const {
    label,
    form,
    field,
    options,
    onChange,
    errors,
    inputErrors,
    required,
    sx
  } = props

  return (
    <FormControlWithErrorHelper
      required={required}
      errorsObject={errors} // legacy errors object. TODO: rename prop to "errors"
      inputErrors={inputErrors}
      errorField={field}
    >
      <FormLabel htmlFor={field}>{label}</FormLabel>
      <Select
        id={field}
        value={form[field]}
        onChange={onChange(field)}
        variant='outlined'
        displayEmpty
        fullWidth
        name={field}
        inputProps={{
          name: field,
          id: field
        }}
        sx={sx}
      >
        {options.map(([value, name]) => (
          <MenuItem key={value} value={value}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControlWithErrorHelper>
  )
}

export default FormSelectWithValidation
